//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  return <Avatar src="/avatar.png" alt="User" {...other} />;
}
